import MarketCapDiversificationContainer from "./MarketCapDiversificationContainer";
import MarketCapDiversificationStore from "./MarketCapDiversificationStore";

export default MarketCapDiversificationStore(MarketCapDiversificationContainer);